import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-language-select',
  templateUrl: './language-select.component.html'
})
export class LanguageSelectComponent implements OnInit {

  currentLanguage: string;
  availableLanguages: Array<string>;

  constructor(private translate: TranslateService, private languageService: LanguageService, private titleService: Title) {
    this.currentLanguage = translate.currentLang;
    translate.onLangChange.subscribe((langChange: LangChangeEvent) => this.currentLanguage = langChange.lang);
    this.availableLanguages = translate.getLangs();
  }

  ngOnInit() {
    document.addEventListener('touchstart', () => {}, false); // iOS hover fix
  }

  changeLanguage(lang: string) {
    this.languageService.changeLanguage(lang).subscribe(res => {
      this.currentLanguage = this.translate.currentLang;
      this.titleService.setTitle(this.translate.instant('BASE_TITLE'));
    });
  }

}
